var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('quotationTable',{attrs:{"tabShow":'pending',"unfixedTableThead":_vm.unfixedTableThead,"tableData":_vm.tableData,"totalNum":_vm.totalNum},on:{"handleClick":_vm.handleClick,"child-event":_vm.getLists}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }